module.exports = __webpack_public_path__ + "assets/img/iconfont.b5c17ef1.svg";